import { ReactNode } from "react";
import { ProNavigation } from "@/components/ProNavigation";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

export function PageContainer({ children, className = "" }: PageContainerProps) {
  return (
    <div className="min-h-screen bg-gradient-hero">
      <ProNavigation />
      <div className={`container mx-auto px-3 sm:px-4 py-6 sm:py-8 ${className}`}>
        {children}
      </div>
    </div>
  );
}
